import _ from 'lodash';
import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ESignatureComponent from './ESignatureComponent';
import DropdownModal from './DropdownModal';
import { ReactComponent as DocumentIcon } from '../../../../icons/document.svg';
import { formikPropType } from '../../../../common/prop-types';

export default function FormikEnabledESignatureComponent({
  attributeObj,
  formik,
  isCommonFieldDisabled,
  print,
  ...props
}) {
  const { assigneeDetails = [] } = props;
  const err = _.get(formik, `errors.${attributeObj.id}`);
  const { label: fieldName, id: attributeObjId, disabled, showAccept } = attributeObj;
  const uploadedFileObj = _.get(formik.values, attributeObjId);
  const isSigned = !!(uploadedFileObj && uploadedFileObj.key);
  const [accepted, updateAccepted] = useState(isSigned);
  const onChange = useCallback(
    (uploadFileObject) => {
      formik.setFieldValue(attributeObjId, uploadFileObject, false);
    },
    [attributeObjId, formik]
  );

  useEffect(() => {
    updateAccepted(isSigned);
  }, [isSigned]);

  return (
    <div style={{ padding: '12px 24px' }} className="e-signature-holder">
      {!print && showAccept && (
        <div style={{ marginBottom: '5px', pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? 0.45 : 1 }}>
          {accepted && (
            <i
              onClick={() => {
                if (isSigned) {
                  return;
                }
                updateAccepted(!accepted);
              }}
              style={{ cursor: isSigned ? 'default' : 'pointer' }}
              className="fa fa-check-square ag-grid-checkbox"
            />
          )}
          {!accepted && (
            <i
              onClick={() => {
                updateAccepted(!accepted);
              }}
              style={{ cursor: 'pointer' }}
              className="fa fa-square ag-grid-checkbox"
            />
          )}
          <label
            onClick={() => {
              if (isSigned && accepted) {
                return;
              }
              updateAccepted(!accepted);
            }}
            style={{ cursor: isSigned && accepted ? 'default' : 'pointer', marginLeft: '5px' }}
          >
            I Accept
          </label>
        </div>
      )}
      <ESignatureComponent
        fieldName={fieldName}
        disabled={disabled || isCommonFieldDisabled}
        onChange={onChange}
        err={err}
        uploadedFileObj={uploadedFileObj}
        showESignOption={!showAccept || (accepted && !isSigned)}
        showManualUploadOption={!showAccept || (!accepted && !isSigned)}
        isRequired={attributeObj?.isRequired}
        assigneeDetails={assigneeDetails}
        isRequiredOnCreation={attributeObj?.isRequiredOnCreation}
        isCreate={!attributeObj?.taskId}
      />
      {!print && (
        <>
          <ModalsInSignature buttonLabel="Opt out" modalContent={attributeObj.optout} />
          <ModalsInSignature buttonLabel="Clause" modalContent={attributeObj.clause} />
        </>
      )}
    </div>
  );
}

FormikEnabledESignatureComponent.propTypes = {
  attributeObj: PropTypes.object.isRequired,
  formik: formikPropType.isRequired,
  isCommonFieldDisabled: PropTypes.bool,
  print: PropTypes.bool,
  assigneeDetails: PropTypes.array,
};

export function ModalsInSignature({ buttonLabel, modalContent }) {
  const [open, setOpen] = useState(false);
  if (!modalContent) return null;
  return (
    <DropdownModal
      openModal={open}
      setOpenModal={setOpen}
      title={buttonLabel}
      content={modalContent}
      trigger={
        <button style={{ display: 'block', padding: '4px 8px' }} className="transparent-button" type="button">
          <DocumentIcon /> <span style={{ marginLeft: '4px' }}>{`${buttonLabel} Agreement`}</span>
        </button>
      }
    />
  );
}

ModalsInSignature.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  modalContent: PropTypes.string,
};
